import { Link } from "gatsby"
// import { Navbar, Nav, NavDropdown } from "react-bootstrap"
import { Navbar, Nav, Form, FormControl, Button } from "react-bootstrap"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header>
    <Navbar fixed="top" expand="lg" variant="light">
      <Link className="navbar-brand" to="/">
        Sentosa Restaurant
      </Link>

      {/* <Navbar.Brand href="#home">Navbar with text</Navbar.Brand> */}
      <Navbar.Toggle aria-controls="basic-navbar-nav" />

      {/* <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav">
          <li className="nav-item active">
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/menu" className="nav-link">
              Menu
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link">
              Contact
            </Link>
          </li>
        </ul>
      </div> */}

      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Link
            to="/"
            className="nav-link-custom"
            activeStyle={{
              fontWeight: 700,
              textDecoration: "underline",
            }}
          >
            <Nav.Link as="span" eventKey="home">
              HOME
            </Nav.Link>
          </Link>
          <Link
            to="/about"
            className="nav-link-custom"
            activeStyle={{
              fontWeight: 700,
              textDecoration: "underline",
            }}
          >
            <Nav.Link as="span" eventKey="about">
              ABOUT
            </Nav.Link>
          </Link>
          <Link
            to="/menu"
            className="nav-link-custom"
            activeStyle={{
              fontWeight: 700,
              textDecoration: "underline",
            }}
          >
            <Nav.Link as="span" eventKey="menu">
              MENU
            </Nav.Link>
          </Link>
          <Link
            to="/contact"
            className="nav-link-custom"
            activeStyle={{
              fontWeight: 700,
              textDecoration: "underline",
            }}
          >
            <Nav.Link as="span" eventKey="contact">
              CONTACT
            </Nav.Link>
          </Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
